import React, { useEffect, useState } from "react";
import Modal from "@mui/material/Modal";
import {
  Button,
  TextField,
  Box,
  Typography,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import { ToastContainer, toast } from "react-toastify";
import { useAuth } from "../../Context/AuthContext";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_REST_URL;

const style = {
  position: "absolute",
  top: "54%",
  // left: "50%",
  right: "380px",
  transform: "translate(90%, -50%)",
  width: 400,
  height: 620,
  overflow: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  borderRadius: "12px",

  scrollbarWidth: "thin", // For Firefox
  scrollbarColor: "#d9d9d9 #fff", // For Firefox
  "&::-webkit-scrollbar": {
    width: "2px",
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#d9d9d9",
  },
};

function UpdateReferrals({
  isEditDialogOpen,
  handleCloseEditDialog,
  clientList,
  selectedId,
  roleId,
  onStatusUpdate,
  onUpdateSuccess, // Pass the callback function
}) {
  const { token } = useAuth();

  const [rmOptions, setRmOptions] = useState([]);
  const [managerIdNameMap, setManagerIdNameMap] = useState({});

  const {
    register,
    handleSubmit,
    reset,
    watch,
    control,
    setValue,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onTouched" });

  console.log("clientList:", clientList[0]?.created_date);

  React.useEffect(() => {
    if (isEditDialogOpen && selectedId) {
      const existingData = clientList.find(
        (client) => client.id === selectedId
      );
      if (existingData) {
        setValue("id", existingData.id);
        setValue(
          "referralName",
          `${existingData.firstname} ${existingData.lastname}`
        );
        setValue("email", existingData.email);
        setValue("phone", existingData.phone);
        const formattedCreated_date = existingData.created_date
          ? existingData.created_date.slice(0, 10)
          : "";
        setValue("created_date", formattedCreated_date);
        setValue("referredByName", existingData.referredByName);
        // setValue("managerName", existingData.managerName);
        setValue("managerId", existingData.managerId);

        const formValues = getValues();
        setValue("managerName", managerIdNameMap[formValues.managerId]);

        setValue("location", existingData.location);
        setValue("automobileOwned", existingData.automobileOwned);
        setValue("description", existingData.description);
        setValue("clubMembership", existingData.clubMembership);
        setValue("comments", existingData.comments);
      }
    }
  }, [isEditDialogOpen, selectedId, setValue, getValues, clientList]);

  const handleReferralNameChange = (event) => {
    const fullName = event.target.value;
    const [firstname, lastname] = fullName.split(" ");
    setValue("firstname", firstname);
    setValue("lastname", lastname);
  };

  //------------------------------for Manager list-----------------------------

  useEffect(() => {
    const handleRole = async () => {
      try {
        console.log("roles", roleId);
        const apiResult = await axios.post(
          `${apiUrl}/CCE/api/v1/userEngine/users`,
          {
            roleId: 2,
          }
        );
        const options = apiResult?.data?.response || [];
        setRmOptions(options);

        const idNameMap = options.reduce((map, option) => {
          map[option.id] = option.firstname + " " + option.lastname;
          return map;
        }, {});
        setManagerIdNameMap(idNameMap);
      } catch (error) {
        console.error("Error fetching rm data:", error.message);
      }
    };

    handleRole();
  }, [roleId]);

  console.log("rmOptionsNew", rmOptions);

  // -----------------------------edit Api handling-------------------------------|\

  const onSubmit = async (data) => {
    console.log("update button call");
    const headers = {
      "x-access-token": token,
    };
    try {
      const response = await axios.put(
        `${apiUrl}/CCE/api/v1/referalEngine/updateReferral`,
        {
          ...data,
          referredId: selectedId,
        },
        { headers }
      );
      console.log(data, "payloadd");
      if (response?.data?.statusMessage === "Success") {
        toast.success("Response updated successfully");
        // onStatusUpdate("success");
        onUpdateSuccess();
      } else {
        toast.error("Update failed");
        onStatusUpdate("failure");
      }
      console.log("response edit", response.data.statusMessage);
    } catch (error) {
      toast.error("Update failed");
      onStatusUpdate("failure");
    }

    reset();
    handleCloseEditDialog();
  };

  //-----------------cancel------------------|\

  const cancelHandler = () => {
    handleCloseEditDialog();
    reset();
  };

  // ---------------------------------------------------------|\

  return (
    <div>
      <ToastContainer
        position="bottom-right"
        autoClose={7000}
        newestOnTop={true}
        closeOnClick
        pauseOnHover
        toastStyle={{ textAlign: "left" }}
        theme="colored"
      />
      <Modal
        open={isEditDialogOpen}
        onClose={handleCloseEditDialog}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ marginBottom: "1rem", textAlign: "center" }}
          >
            Update Referral
          </Typography>
          <form onSubmit={handleSubmit(onSubmit)}>
            {/* ------------------------edit--------------------------- */}
            {/* <div>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-basic"
                label="ID"
                variant="outlined"
                readOnly
                value={selectedId}
                disabled
              />
              {errors.id && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.id.message}
                </div>
              )}
            </div> */}
            {/* ------------------------------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-basic"
                label="Referral Name"
                variant="outlined"
                {...register("referralName", {
                  required: "Referral Name is required",
                  errorMessage: "Referral Name is allowed in only letters",
                  pattern: {
                    value: /^[A-Za-z]+(?: [A-Za-z]+)?$/,
                    message: "Only alphabets are allowed",
                  },
                })}
                onChange={handleReferralNameChange}
              />
              {errors.referralName && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.referralName.message}
                </div>
              )}
            </div>
            {/* //*************************************************************************/}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-basic"
                label="Email address"
                variant="outlined"
                {...register("email", {
                  // required: "Email address is required",
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: "Invalid Email Address",
                  },
                })}
              />
              {errors.email && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.email.message}
                </div>
              )}
            </div>
            <div style={{ margin: "16px 0px 14px 0px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-basic"
                label="Phone number"
                variant="outlined"
                inputProps={{ maxLength: 10 }}
                {...register("phone", {
                  required: "Phone number is required",
                  pattern: {
                    value: /^\d{10}$/,
                    message: "Invalid Phone Number (10 digits)",
                  },
                  validate: (value) =>
                    !!value || !!watch("email") || "Phone is required",
                  onChange: (e) =>
                    (e.target.value = e.target.value.replace(/\D/g, "")),
                })}
              />
              {errors.phone && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.phone.message}
                </div>
              )}
            </div>
            {/* ----------------------------------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-date"
                label="Created Date"
                type="date"
                variant="outlined"
                disabled
                InputLabelProps={{
                  shrink: true,
                }}
                {...register("created_date", {
                  // required: "date is required",
                })}
                InputProps={{
                  inputProps: {
                    placeholder: "Select Date",
                  },
                }}
              />
              {errors.created_date && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.created_date.message}
                </div>
              )}
            </div>
            {/*----------------------------------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-referredByName"
                label="Referred by"
                type="referredByName"
                variant="outlined"
                disabled
                {...register("referredByName", {
                  // required: "Referred by is required",
                })}
              />
              {errors.referredByName && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.referredByName.message}
                </div>
              )}
            </div>
            {/*----------------------------------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <FormControl fullWidth variant="outlined" size="small">
                <InputLabel id="rm-select-label">Wealth Advisor</InputLabel>
                <Controller
                  name="managerId"
                  control={control}
                  defaultValue={null}
                  rules={{
                    required: "Manager Name is required ",
                  }}
                  render={({ field }) => (
                    <Select
                      label="Wealth Advisor"
                      labelId="rm-select-label"
                      {...field}
                      sx={styles.textfield}
                    >
                      {rmOptions.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.firstname} {option.lastname}
                        </MenuItem>
                      ))}
                    </Select>
                  )}
                />
              </FormControl>
              {errors.manager && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.manager.message}
                </div>
              )}
            </div>
            {/* *******************************new extra field******************************* */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-location"
                label="Location"
                type="location"
                variant="outlined"
                {...register("location", {
                  // required: "Location is required",
                })}
              />
              {errors.location && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.location.message}
                </div>
              )}
            </div>
            {/* ------------------------------------------ */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-automobileOwned"
                label="Automobile Owned"
                type="automobileOwned"
                variant="outlined"
                {...register("automobileOwned", {
                  // required: "Referred by is required",
                })}
              />
              {errors.automobileOwned && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.automobileOwned.message}
                </div>
              )}
            </div>
            {/* ------------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-clubMembership"
                label="Club Membership"
                type="clubMembership"
                variant="outlined"
                {...register("clubMembership", {
                  // required: "Club membership by is required",
                })}
              />
              {errors.clubMembership && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.clubMembership.message}
                </div>
              )}
            </div>
            {/* ------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-description"
                label="Good About Referral"
                type="description"
                variant="outlined"
                {...register("description", {
                  // required: "Club membership by is required",
                })}
              />
              {errors.description && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.description.message}
                </div>
              )}
            </div>
            {/* ------------------------------------- */}
            <div style={{ marginTop: "16px" }}>
              <TextField
                size="small"
                sx={styles.textfield}
                id="outlined-comments"
                label="Comments"
                type="comments"
                variant="outlined"
                {...register("comments", {
                  // required: "Comments by is required",
                })}
              />
              {errors.comments && (
                <div
                  style={{
                    color: "red",
                    fontSize: "14px",
                    textAlign: "left",
                    marginLeft: "10px",
                  }}
                >
                  {errors.comments.message}
                </div>
              )}
            </div>

            {/*********************************************************************************/}
            <Box
              sx={{
                display: "flex ",
                justifyContent: "center",
                marginTop: "1rem",
              }}
            >
              <Button
                onClick={cancelHandler}
                variant="outlined"
                sx={{
                  color: "Black",
                  marginRight: "10px",
                  textTransform: "none",
                }}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="outlined"
                sx={{
                  padding: "5px 15px",
                  background: "#002C51",
                  color: "#fff",
                  marginLeft: "10px",
                  textTransform: "none",
                  "&:hover": { background: "#002C51" },
                }}
              >
                Update
              </Button>
            </Box>
          </form>
        </Box>
      </Modal>
    </div>
  );
}

export default UpdateReferrals;

const styles = {
  textfield: {
    width: "335px",
  },
};
